<template>
    <div class="bid-writing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Bid Writing Support
                </div>
                <div class="logo">
                    <img src="/images/bws-logo.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Preferred Affiliate Partner for Bid Writing & Tender Support</h1>
                <p>
                    We're pleased to introduce Bid Writing Service (BWS), a preferred affiliate partner available exclusively through Connect for Approved Commercial Partners (ACPs).                </p>
                <p>
                    BWS is a specialist bid writing and management consultancy that helps businesses secure more contracts through professional bid writing, tender management, framework applications and social value consultancy. Acting as an extension of your team, they provide flexible support tailored to your bid requirements, experience and growth objectives.
                </p>
                <p>
                    As an Approved Commercial Partner, you can access exclusive discounted rates negotiated through Epwin Window Systems.
                </p>
                <p><img src="/images/bid-writing-who-are-bws.png"></p>
            </div>
            <div class="box-2">
                <div>
                    <img src="/images/bws-image-1.png">
                </div>
                <div>
                    <img src="/images/bws-image-2.png">
                </div>
            </div>
            <div class="box-3">
                <h1>What do BWS offer?</h1>
                <p>
                    Work with one-off and long-term retainer clients, offering expert services tailored to any client, regardless of bidding experience, growth objectives or company size.
                    Bid Writing
                </p>
                <p>
                    End-to-end bid writing with full project management, guiding you from concept to completion.
                </p>
                <p>
                    Bid Preparation & Bid Review
                </p>
                <p>
                    Expert support preparing tender content and documentation, delivered in a tailored Bid Ready pack.
                    Bid Management
                </p>
                <p>
                    Comprehensive management, including stakeholder coordination and governance activities.
                </p>
                <p>
                    Detailed feedback and recommendations aligned to evaluation criteria, strengthening your bid before submission.
                </p>
                <h2>
                    PLUS
                </h2>
                <ul>
                    <li>
                        Framework Applications
                    </li>
                    <li>
                        Bid Libraries
                    </li>
                    <li>
                        Social Value Consultancy
                    </li>
                </ul>
            </div>
            <div class="box-4">
                <h1>
                    Exclusive Offers for Approved Commercial Partners
                </h1>
                <h2>
                    Partners introduced via Epwin Window Systems benefit from exclusive discounted rates.
                </h2>
                <table class="table _lined">
                    <thead>
                    <tr>
                        <th>Services</th>
                        <th>Description</th>
                        <th>Price</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            Bid Health Check (Review and Comment)
                        </td>
                        <td>
                            Independent review with commentary aligned to evaluation criteria
                        </td>
                        <td>
                            £850 + VAT
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Bid Health Check (Review and Improve)
                        </td>
                        <td>
                            Detailed feedback alongside enhancement of the content
                        </td>
                        <td>
                            £2,000 + VAT
                        </td>
                    </tr>
                    <tr>
                        <td rowspan="3">
                            Total Bid Management & Writing Services
                        </td>
                        <td>
                            Upto 5,000 words
                        </td>
                        <td>
                            £2,200 Fixed Fee + £700 Win Bonus
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Between 5,000-10,000 words
                        </td>
                        <td>
                            £3,200 Fixed Fee + £1,000 Win Bonus
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Above 10,000 words
                        </td>
                        <td>
                            £4,900 Fixed Fee + £1,000 Win Bonus
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Social Value Consultancy
                        </td>
                        <td>
                            Standalone service
                        </td>
                        <td>
                            £1,500 + VAT
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-5">
                <h1>Interested in speaking to BWS?</h1>
                <p>
                    Complete the Bid Support Enquiry form and the Commercial Marketing team will make an introduction on your behalf.
                </p>
                <div>
                    <a class="btn-primary-outline _lg" @click.prevent="openEnquiryBox()">
                        Request a Bid Support Introduction
                    </a>
                </div>
            </div>
            <div class="box-6">
                <div>
                    <img src="/images/bws-image-3.png">
                </div>
                <div>
                    <img src="/images/bws-image-4.png">
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Bid Support Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        {{ enquiry_box_copy }}
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            enquiry_box_copy: 'Please enter details of your enquiry below.',
            enquiry_box_open: false,
            enquiry_message: 'I would like an introduction to the Bid Writing Support partner',
            sending: false,
        }
    },
    methods: {
        openEnquiryBox() {
            this.enquiry_box_open = true;
        },
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 59,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Bid Writing Service enquiry',
                'value': 'Bid Writing Service enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
        partnerLinkClicked() {
          axios.post('/activity-logs/createActivityLogFromRequest', {
            'activity_log_category_id': 3,
            'description': `Partner Link Clicked - Bid Writing Service`,
          });
          gtag('event', 'partner_link_clicked', {
            'event_category': 'link',
            'event_label': 'Bid Writing Service partner link clicked',
            'value': 'Bid Writing Service partner link clicked',
          });
        },
    },
};
</script>
